import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

export default class extends Controller {
  connect() {
    this.element.setAttribute("autocomplete", "none")

    const config = {
      valueField: "id",
      labelField: "name",
      searchField: ["id", "name_with_number", "full_address"],
      selectOnTab: true,
      openOnFocus: true,
      placeholder: "Start typing to search for a facility...",
      maxItems: 1,
      closeAfterSelect: true,
      load: this.loadOptions,
      render: {
        option: this.renderOption,
        item: this.renderItem
      }
    }

    new TomSelect(this.element, config)
  }

  renderItem(facility, escape) {
    return `<div>${escape(facility.name_with_number)}</div>`
  }

  renderOption(facility, escape) {
    return `
    <div>
      ${escape(facility.name_with_number)} <small><i>${escape(facility.full_address)}</i><small>
    </div> `
  }

  loadOptions(query, callback) {
    const url = `${this.input.dataset.url}?search=${encodeURIComponent(query)} `

    fetch(url)
      .then(response => response.json())
      .then(json => {
        callback(json)
      }).catch(() => {
        callback()
      })
  }
}


